/* beautiful-react-hooks version: 0.35.0 */
import useDidMount from './useDidMount.js';
import useWillUnmount from './useWillUnmount.js';

var useLifecycle = function useLifecycle(mount, unmount) {
  var onDidMount = useDidMount(mount);
  var onWillUnmount = useWillUnmount(unmount);
  return {
    onDidMount: onDidMount,
    onWillUnmount: onWillUnmount
  };
};

export default useLifecycle;
